module.exports = __webpack_public_path__ + "static/media/linkedin.53e90ef3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Person/linkedin.svg
// module id = 195
// module chunks = 0